import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { ArrowLeft } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipTrigger } from '~/common/components/ui/tooltip';
import { useStandaloneMode } from '~/common/hooks/useStandaloneMode';

export function BreadcrumbBackButton() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isStandalone = useStandaloneMode();

  if (!isStandalone) return null;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button type="button" onClick={() => navigate(-1)} className="text-muted-foreground" aria-label={t('Zurück')} data-testid="breadcrumb-back-button">
          <ArrowLeft size={20} />
        </button>
      </TooltipTrigger>
      <TooltipContent>{t('Zurück')}</TooltipContent>
    </Tooltip>
  );
}
